// extracted by mini-css-extract-plugin
module.exports = {"item":"TodoItem_item__1tFjT","completed":"TodoItem_completed__19Fz5","controlButtons":"TodoItem_controlButtons__3s_ZD"};